export default (ts) => {
  // IE support
  const d = ts ? new Date(ts) : new Date();
  ts = d.getTime();
  const localOffset = d.getTimezoneOffset() * 60000;
  const moOffset = 3600000 * 8;
  return new Date(ts + localOffset + moOffset);
}